<template>
<vs-row align="center" class="popup-content p-4">
    <!-- Texto inicial (solo visible si NO hay libro destino seleccionado) -->
    <vs-col v-if="!libroSelecttranferir" vs-w="12" vs-type="flex" vs-justify="center" vs-align="center" class="mb-6">
        <div class="info-box">
            <p class="info-title">📘 Copia de Planificaciones</p>
            <p class="info-description">
                Selecciona el libro destino para copiar las planificaciones.
            </p>
        </div>
    </vs-col>
    <!-- Selector libro destino -->
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
        <label class="mb-2 font-bold">📚 Libro destino:</label>
        <v-select :options="librosFiltrados" class="mb-4 w-full max-w-md" placeholder="--Seleccione el libro destino--" v-model="libroSelecttranferir" label="nombrelibro" :reduce="libro => libro" ref="libroSelecttranferir" :class="classvalidar_libroSelecttranferir" />
    </vs-col>
    <!-- Desde y Hacia visual elegante -->
    <vs-col v-if="libroOrigen && libroSelecttranferir" vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" class="libro-info-card">
        <div class="card-transfer">
            <div class="libro-line">
                <span class="label">Desde</span>
                <span class="value">{{ libroOrigen.nombrelibro }}</span>
            </div>
            <div class="arrow">➡️</div>
            <div class="libro-line">
                <span class="label">Hacia</span>
                <span class="value">{{ libroSelecttranferir.nombrelibro }}</span>
            </div>
        </div>
    </vs-col>
    <!-- Botón -->
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" class="mt-4 mb-4">
        <vs-button @click="libroSeleccionado" type="relief" color="primary" :disabled="!libroSelecttranferir">
            Transferir Planificaciones
        </vs-button>
    </vs-col>
</vs-row>
</template>

<script>
import vSelect from "vue-select";
export default {
    data() {
        return {
            librosFiltrados: [],
            libroSelecttranferir: '',
            classvalidar_libroSelecttranferir: '',
            libroOrigen: null
        };
    },
    components: {
        "v-select": vSelect,
    },
    props: {
        libroSelect: {
            type: Object,
            default: function () {
                return {}
            }
        },
        arrayBooks: {
            type: Array,
            default: function () {
                return []
            }
        },
        bookSelect: {
            type: Number,
            default: 0
        }
    },
    mounted() {
        let me = this;
        me.librosFiltrados = this.arrayBooks.filter(asignaturas => asignaturas.asignatura_idasignatura !== this.bookSelect);
        me.libroOrigen = this.arrayBooks.find(book => book.asignatura_idasignatura === this.bookSelect) || null;
    },
    methods: {
        validarcampo_buscar_libroSelecttranferir() {
            let me = this;
            const focus_libroSelecttranferir = me.$refs.libroSelecttranferir.$el.querySelector('input');
            focus_libroSelecttranferir.focus();
            me.classvalidar_libroSelecttranferir = 'stylevalidar';
            //Notificación de vacio
            me.$vs.notify({
                text: "Seleccione el libro que va a recibir la transferencia de planificaciones.",
                color: 'warning',
                iconPack: 'feather',
                icon: 'icon-alert-triangle',
                time: 8000,
            });
            // Quitar la clase después de la duración de la animación
            setTimeout(() => {
                me.classvalidar_libroSelecttranferir = '';
            }, 1500); // Ajusta según la duración de tu animación
        },
        libroSeleccionado() {
            let me = this;
            if ((me.libroSelecttranferir == 'undefined') || (me.libroSelecttranferir == '') || (me.libroSelecttranferir == null)) {
                me.validarcampo_buscar_libroSelecttranferir();
                return;
            }
            let usuarioLocal = JSON.parse(localStorage.getItem('usuario'));
            let user_created = usuarioLocal.idusuario;
            let datos = {
                "libro_a_transferir": me.bookSelect,
                "libro_recibir_transferencia": me.libroSelecttranferir.asignatura_idasignatura,
                "user_created": user_created
            }
            console.log(datos, "data a enviar")
            console.log(datos);

            // return;
            me.$vs.loading()
            //axios.post(this.$apifacturacion_url + 'f_Vendedor', datos)
            this.$http.post(this.$server_url + 'transferenciaPlanificaciones', datos)
                .then(res => {
                    me.$vs.loading.close()
                    // this.getMaterialcubiertaParametro();
                    me.$vs.notify({
                        text: 'Planificaciones transferidas con éxito.',
                        color: 'success',
                        iconPack: 'feather',
                        icon: 'icon-check'
                    })
                    this.$emit('change', {
                        verificacionemittransferencia: 1
                    });
                })
                .catch(function () {
                    me.$vs.loading.close()
                    me.$vs.notify({
                        text: 'Las planificaciones no se pudieron transferir',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-x'
                    })
                })
        },
        //SECCION GUARDAR NUEVO PRODUCTO
        // getNuevoContUserAgrupacion() {
        //     this.nuevoarray.ca_id = ''
        //     this.nuevoarray.idusuario = ''
        // },
    },
};
</script>

<style scoped>
.informacionformhijodehijo {
    z-index: 51002;
    /* Valor mayor que el del popup del padre */
    position: fixed;
    /* Asegúrate de que la posición sea adecuada */
}

.stylevalidar {
    /* border: 2px solid #00f; */
    box-shadow: 0px 0px 2px 4px #ff0000;
    border-radius: 5px;
}

.popup-content {
    width: 100%;
    padding: 30px 20px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 2px;
}

.info-box {
    background-color: #ffffff;
    border-radius: 14px;
    padding: 28px 32px;
    max-width: 560px;
    margin: 0 auto 24px auto;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    font-family: 'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    color: #2e3a59;
    text-align: center;
    user-select: none;
}

.info-title {
    font-weight: 700;
    font-size: 1.55rem;
    margin-bottom: 18px;
    color: #1f2a47;
    letter-spacing: 0.02em;
    line-height: 1.2;
}

.info-description {
    font-size: 1.125rem;
    line-height: 1.55;
    color: #4a5678;
    margin-bottom: 0;
}

.libro-info-card {
    margin-top: 20px;
    margin-bottom: 16px;
    display: flex;
    justify-content: center;
}

.card-transfer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #f8fafc;
    border-radius: 14px;
    padding: 20px 28px;
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
    font-size: 1.125rem;
    font-weight: 500;
    max-width: 500px;
    width: 100%;
    gap: 20px;
    text-align: center;
}

.libro-line {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
}

.label {
    font-weight: 700;
    color: #2563eb;
    font-size: 0.95rem;
}

.value {
    color: #334155;
    font-weight: 600;
}

.arrow {
    font-size: 1.5rem;
    color: #64748b;
}

.v-select {
    max-width: 480px;
    width: 100%;
    margin-bottom: 12px;
}

.vs-col label.font-bold {
    font-weight: 700;
    font-size: 1rem;
    color: #34495e;
    margin-bottom: 8px;
    display: inline-block;
}

.vs-button {
    min-width: 180px;
    font-weight: 600;
    font-size: 1rem;
    border-radius: 8px;
    padding: 10px 24px;
    box-shadow: 0 4px 10px rgba(59, 130, 246, 0.3);
    transition: background-color 0.3s ease;
}

.vs-button[type='relief'][color='primary']:hover:not(:disabled) {
    background-color: #2563eb;
    box-shadow: 0 6px 14px rgba(37, 99, 235, 0.5);
    cursor: pointer;
}

.vs-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

@media (max-width: 600px) {
    .info-box {
        padding: 20px 18px;
        max-width: 100%;
    }

    .card-transfer {
        flex-direction: column;
        gap: 12px;
        padding: 16px 20px;
    }

    .arrow {
        transform: rotate(90deg);
    }

    .vs-button {
        width: 100%;
        min-width: auto;
    }
}
</style>
